<template>
    <div class="wtw-container store-list-container clearfix">
        <div class="option button full-width outline"
             v-for="option in options"
             @click.stop="toggleOption(option.product_option_value_id)"
             :class="{active: optionActive(option.product_option_value_id) || allActive}"
        >
            <img :src="option.product_option_value_image_url"/>
        </div>
    </div>
</template>

<script>

    export default{
        data() {
            return {
                optionValues: [],
                allActive: false,
            }
        },
        props:['options', 'sendOptions', 'optionsAll', 'optionsSelected'],
        created(){
            if(this.optionsSelected) {
                this.optionValues = this.optionsSelected
            }
        },
        methods:{
            toggleOption(optionValue){
                let index = this.optionIndex(optionValue);
                if(index !== -1){
                    this.optionValues.splice(index, 1);
                } else {
                    this.optionValues.push(optionValue);
                }
                !this.anyOptionsActive ?  this.allActive = true : this.allActive = false;
            },
            optionIndex(optionValue){
                return this.optionValues.indexOf(optionValue);
            },
            optionActive(optionValue){
                return this.optionIndex(optionValue) !== -1;
            }
        },
        computed: {
            anyOptionsActive(){
                return this.optionValues.length;
            }
        },
        watch: {
            sendOptions: function () {
                if (this.sendOptions) {
                    let optionIds = this.options.map((option) => {
                        return option.product_option_value_id;
                    });
                    // prevent duplicates in selected array
                    this.$parent.$emit('removeOptions', optionIds)
                    this.$parent.$emit('optionsSending', this.optionValues, true);
                }
            }
        },
        mounted(){
            if(!this.optionsSelected || (this.optionsSelected && !this.optionsSelected.length)) {
                this.allActive = true;
            }
        },
    }
</script>